var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:[
        'mdc-deprecated-list',
        _vm.twoLine && 'mdc-deprecated-list--two-line'
    ],attrs:{"role":_vm.listRole}},_vm._l((_vm.listItems),function(item,index){return _c('list-item',{key:("menuitem-" + index),attrs:{"tabindex":index === 0 ? 0 : -1,"data-item-index":index,"item":item},nativeOn:{"click":function($event){return _vm.$emit('click', item)}},scopedSlots:_vm._u([{key:"text",fn:function(ref){
    var text = ref.text;
return [_vm._t("text",null,{"text":text})]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }